export default "__VITE_ASSET__0c4b5e12__"